// Adding extra 1.5 pixels to a minimal border size to reduce GPU aliasing artifacts
export const getStrokeWidth = stroke => (stroke >= 1.5 ? stroke : 1.5);
